import {
    CLEAR_ERRORS,
    GET_SUPPLIER_TRANSACTIONS, GET_SUPPLIERS_TRANSACTIONS, SET_LOADING,
    SUPPLIER_TRANSACTION_ERROR, UNSET_LOADING
} from '../actions/types';

const initialState = {
    supplier_transactions: [],
    dates: [],
    all_transactions: [], // Store all transactions for local pagination
    suppliers_transactions: [],
    suppliers_transaction: {},

    suppliers_DATA: [],
    filtered_suppliers_transactions: [],
    update_suppliers_transaction: null,
    update_suppliers_transaction_for_supplier: null,
    delete_suppliers_transaction: null,
    loading: true,
    numberOfPages: 1,
    currentPage: 1,
    total_suppliers_transactions: null,
    itemsPerPage: 10, // Default items per page
    total_suppliers: null,
    error: null,
};

// Helper to paginate data locally
const paginateData = (data, currentPage, itemsPerPage) => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data.slice(startIndex, endIndex);
};

// Helper to calculate total pages
const calculateTotalPages = (totalItems, itemsPerPage) => {
    return Math.ceil(totalItems / itemsPerPage);
};

// eslint-disable-next-line
export default function (state = initialState, action) {
    const {type, payload} = action;

    switch (type) {
        case SET_LOADING:
            return {
                ...state,
                loading: true,
            }
        case UNSET_LOADING:
            return {
                ...state,
                loading: false,
            }
        case GET_SUPPLIERS_TRANSACTIONS:
            return {
                ...state,
                dates: payload.dates,
                supplier_transactions: payload.suppliers.data,
                numberOfPages: payload.suppliers.last_page,
                current_page: payload.suppliers.current_page,
                suppliers_data: payload,
                error: null,
                loading: false,
            };

        case GET_SUPPLIER_TRANSACTIONS:
            // Handle the case when the API doesn't return pagination metadata
            const allTransactions = payload.data || [];
            const currentPage = payload.meta?.current_page || state.currentPage || 1;
            const itemsPerPage = state.itemsPerPage;
            const totalItems = allTransactions.length;
            const numberOfPages = payload.meta?.last_page || calculateTotalPages(totalItems, itemsPerPage);
            
            // If meta is not provided, use local pagination
            const paginatedData = payload.meta 
                ? allTransactions  // API already paginated the data
                : paginateData(allTransactions, currentPage, itemsPerPage);
            
            return {
                ...state,
                supplier_transactions: paginatedData,
                all_transactions: allTransactions, // Store all transactions for local pagination
                numberOfPages: numberOfPages,
                currentPage: currentPage,
                total_suppliers_transactions: payload.meta?.total || totalItems,
                error: null,
                loading: false,
            };
            
        case SUPPLIER_TRANSACTION_ERROR:
            return {
                ...state,
                error: payload,
                loading: false,
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
                loading: false,
            };

        default:
            return state;
    }
}
